<style lang="less" scoped>
  .register-index-container {
    min-height: 100%;
  }
  .content {
    width: 840px;
    margin: 0 auto;
  }
  .logo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
  }
  .logo {
    width: 256px;
    height: 32px;
    background-image: url(~@/assets/icon-bi-h.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .tab {
    display: flex;
    width: 100%;
    height: 100px;
  }
  .tab-item {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e3e3e3;

    &::before {
      position: absolute;
      top: 16px;
      left: 16px;
      color: rgba(176, 176, 176, 0.5);
      font-weight: bold;
      font-size: 15px;
    }

    &:nth-of-type(1) { &::before { content: '01'; } }
    &:nth-of-type(2) { &::before { content: '02'; } }
    &:nth-of-type(3) { &::before { content: '03'; } }
    &:nth-of-type(4) { &::before { content: '04'; } }

    &:not(:first-of-type) {
      border-left: 0;
    }

    &.active {
      background-color: #ff6c00;
      border-color: #ff6c00;
      &::before {
        color: rgba(255, 255, 255, 0.5);
      }
      & + div {
        border-left-color: #ff6c00;
      }
      .tab-name {
        color: #fff;
      }
    }
  }
  .tab-name {
    color: #b0b0b0;
    font-size: 15px;
  }
</style>

<template lang="pug">
  .register-index-container
    section.content
      .logo-wrapper
        h1.logo
      .tab
        .tab-item(:class="{ active: registerType === 'terms' || registerType === 'form'}")
          strong.tab-name 기업회원 정보입력
        .tab-item(:class="{ active: registerType === 'review' }")
          strong.tab-name 입점 심사
        .tab-item(:class="{ active: registerType === 'payment' }")
          strong.tab-name 상품 셋팅 / 비용 결제
        .tab-item
          strong.tab-name 쇼핑몰 / 상품 노출
      .body
        router-view
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RegisterIndex',
  computed: {
    ...mapState({
      registerType: state => state.route.params.registerType,
    }),
  },
};
</script>
